import { Serie } from '@nivo/line';
import { ChartData } from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';

/**
 *
 * @param chartData Parameter that receives from the response of the charts request
 * @returns Array with of the data converted to the chart component
 */
function useConvertChartData(chartData?: ChartData) {
  /**
   *
   * This reducer is traversing the months that come from the chartData,
   * its function is traversing the groups of values and relating them to the months
   *
   */
  if (chartData) {
    return Object.keys(chartData).reduce((result, month) => {
      const group = chartData[month];

      /**
       *
       * This datum receives the mapped values of group,
       * referencing the id, and the data as an array of the value of x which is the month
       * and y which is the value corresponding to the month being traversed in the reduce
       *
       */
      const datum: Serie[] = Object.keys(group).map((id) => {
        return {
          id,
          data: [{ x: month, y: group[id] }],
        };
      });

      /**
       *
       * If at this point there is still no data in the result,
       * the datum created in the first index is returned
       *
       */
      if (!result.length) {
        return datum;
      }

      /**
       *
       * With the result already populated, a mapping of the items contained in the result is made,
       * pairing with the data created in datum, and relating the values in order.
       *
       */
      return result.map((item) => {
        const itemFinded = datum.find((datumItem) => datumItem.id === item.id);

        if (itemFinded) {
          return {
            ...item,
            data: [...item.data, ...itemFinded.data],
          };
        }

        return item;
      });
    }, [] as Serie[]);
  }
}

export default useConvertChartData;
